import { useState, useEffect, useCallback } from 'react';
import Skeleton from '@mui/material/Skeleton';
import getCookie from '../../Queries/getCookie';
//Queries
import getAdminCarritoMX from '../../Queries/getAdminCarritoMX';
import postAdminCarritoMX from '../../Queries/postAdminCarritoMX';

//Components
import Button from '@mui/material/Button';
import Alert from '../../Alert';

// Styles
import styles from './index.module.sass';

export default function Preguntas({
  idCuestionario,
  setSessionMessage,
  setIsOpenModal,
  screenSize,
}) {
  const [respuestas, setRespuestas] = useState({});
  const [indicePregunta, setIndicePregunta] = useState(0);
  const [Cuestionario, setCuestionario] = useState([]);
  const [error, setError] = useState('');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const getPreguntas = useCallback(async () => {
    setLoading(true);
    const preguntas = await getAdminCarritoMX({
      tmbservice: 'WebApiAdminCarritoMX/api/CuestionariosUSA/Preguntas',
      jsonBody: { idCuestionario },
    });

    const { codigoMensaje, mensajeEsp, data = {} } = preguntas;

    setSessionMessage(codigoMensaje);

    if (codigoMensaje === 200) {
      setCuestionario(data.preguntas);
    } else {
      alert(mensajeEsp);
    }

    setLoading(false);
  }, [idCuestionario, setSessionMessage]);

  useEffect(() => {
    getPreguntas();
  }, [getPreguntas]);

  const validarPregunta = () => {
    const preguntaActual = Cuestionario[indicePregunta];
    const respuestaTexto = respuestas[`respuesta${preguntaActual.idPregunta}`];

    if (preguntaActual.incisos.length > 1) {
      if (!respuestaTexto) {
        setError('Debes seleccionar una opción.');
        return false;
      }
    } else {
      if (!respuestaTexto || respuestaTexto.trim() === '') {
        setError('Debes escribir una respuesta.');
        return false;
      }
    }

    setError('');
    return true;
  };

  function Siguiente() {
    if (validarPregunta()) {
      setIndicePregunta(indicePregunta + 1);
    }
  }

  function Anterior() {
    setIndicePregunta(indicePregunta - 1);
  }

  const changeValue = (e, idPregunta, idOpcionRespuesta, requiereJustificacion = false) => {
    const { name, value } = e.target;

    setRespuestas((prev) => {
      const nuevasRespuestas = { ...prev };
      // Si es una justificacion
      if (name.startsWith('justificacion')) {
        nuevasRespuestas[name] = value;
      } else {
        // Si selecciona una opción
        nuevasRespuestas[`respuesta${idPregunta}`] = value;
        nuevasRespuestas[`opcion${idPregunta}`] = idOpcionRespuesta;

        // Si la opción NO requiere justificación, eliminar cualquier justificación previa
        if (!requiereJustificacion) {
          delete nuevasRespuestas[`justificacion${idPregunta}`];
        }
      }

      return nuevasRespuestas;
    });
  };

  const preguntaActual = Cuestionario[indicePregunta];

  async function guardarCuestionario() {
    if (validarPregunta()) {
      setLoading(true);
      const respuestasFinales = Cuestionario.map((pregunta) => {
        const idPregunta = pregunta.idPregunta;
        const idOpcionRespuesta = respuestas[`opcion${idPregunta}`] || '';

        let respuesta = '';

        // Si la pregunta tiene justificación requerida y está activa, guardar la justificación
        if (
          pregunta.incisos.some(
            (i) => i.deJustificacion && respuestas[`respuesta${idPregunta}`] === i.opcionRespuesta,
          )
        ) {
          respuesta = respuestas[`justificacion${idPregunta}`] || '';
        } else if (pregunta.incisos.length === 1) {
          // Si es una pregunta abierta, guardar la respuesta
          respuesta = respuestas[`respuesta${idPregunta}`] || '';
        }

        return {
          idPregunta,
          idOpcionRespuesta,
          respuesta,
        };
      });

      try {
        const response = await postAdminCarritoMX({
          tmbservice: 'WebApiAdminCarritoMX/api/CuestionariosUSA/Respuestas',
          jsonBody: {
            idCuestionario,
            respuestas: respuestasFinales,
          },
        });

        if (response.codigoMensaje === 200) {
          setAlertText(
            'Agradecemos tus valiosos comentarios y preferencias, los cuales utilizaremos para diseñar una experiencia a tu medida, asegurando momentos inolvidables que permanecerán para siempre en sus corazones.',
          );
          setOpen(true);
        } else {
          setAlertText('Hubo un error al guardar tu información, intentalo nuevamente');
          setOpen(true);
        }
      } catch (error) {
        console.error('Error al guardar el cuestionario:', error);
      }
      setLoading(false);
    }
  }

  function alertCallback() {
    setIsOpenModal(false);
  }

  return (
    <div className={styles.container}>
      <Alert
        open={open}
        setOpen={setOpen}
        title='Mensaje del sistema'
        text={alertText}
        callback={alertCallback}
      />

      {!loading ? (
        <>
          <div>
            <div className={styles.header}>✨ ¡Felicidades {getCookie('kitName')}✨</div>
            <div className={styles.pregunta}>
              {preguntaActual?.noPregunta}.- {preguntaActual?.pregunta}
            </div>
            <div className={`${styles.inputContainer} ${styles[screenSize]}`}>
              {' '}
              <div className={styles.body}>Respuesta:</div>
            </div>

            {preguntaActual?.incisos.length > 1 ? (
              <div className={`${styles.inputContainer} ${styles[screenSize]}`}>
                <div className={styles.multiple}>
                  {preguntaActual?.incisos.map((inciso) => (
                    <div key={inciso.inciso}>
                      <label>
                        <input
                          type='radio'
                          name={`respuesta${preguntaActual?.idPregunta}`}
                          value={inciso.opcionRespuesta}
                          checked={
                            respuestas[`respuesta${preguntaActual?.idPregunta}`] ===
                            inciso.opcionRespuesta
                          }
                          onChange={(e) =>
                            changeValue(
                              e,
                              preguntaActual?.idPregunta,
                              inciso.idOpcionRespuesta,
                              inciso.deJustificacion,
                            )
                          }
                        />
                        {inciso.opcionRespuesta}
                      </label>
                      {/* Input de justificación si aplica */}
                      {inciso.deJustificacion &&
                        respuestas[`respuesta${preguntaActual?.idPregunta}`] ===
                          inciso.opcionRespuesta && (
                          <div>
                            <input
                              key={`justificacion-${inciso.idOpcionRespuesta}`}
                              type='text'
                              name={`justificacion${preguntaActual?.idPregunta}`}
                              placeholder='Cuéntanos de qué se trata'
                              value={respuestas[`justificacion${preguntaActual?.idPregunta}`] || ''}
                              maxLength={inciso.noMaximoCaracteres}
                              onChange={(e) =>
                                changeValue(
                                  e,
                                  preguntaActual?.idPregunta,
                                  inciso.idOpcionRespuesta,
                                  true,
                                )
                              }
                              className={`${styles.inputText} ${styles.justificacion}`}
                            />
                          </div>
                        )}
                    </div>
                  ))}
                </div>
                {error && <div className={styles.error}>{error}</div>}
              </div>
            ) : (
              <div className={`${styles.inputContainer} ${styles[screenSize]}`}>
                <input
                  type='text'
                  name={`respuesta${preguntaActual?.idPregunta}`}
                  value={respuestas[`respuesta${preguntaActual?.idPregunta}`] || ''}
                  onChange={(e) => changeValue(e, preguntaActual?.idPregunta, '', true)}
                  className={styles.inputText}
                  maxLength={preguntaActual?.incisos[0].noMaximoCaracteres}
                />
                {error && <div className={styles.error}>{error}</div>}
              </div>
            )}
          </div>
          <div className={styles.conteo}>
            {preguntaActual?.noPregunta} de {Cuestionario.length}
          </div>
          <div className={styles.footer}>
            <div>
              {indicePregunta > 0 && (
                <Button className={styles.button} variant='contained' onClick={() => Anterior()}>
                  Anterior
                </Button>
              )}
            </div>
            <div>
              {indicePregunta < Cuestionario.length - 1 && (
                <Button className={styles.button} variant='contained' onClick={() => Siguiente()}>
                  Siguiente
                </Button>
              )}
            </div>

            <div>
              {preguntaActual?.noPregunta === Cuestionario.length && (
                <Button
                  className={styles.button}
                  variant='contained'
                  onClick={() => guardarCuestionario()}>
                  Terminar
                </Button>
              )}
            </div>
          </div>
        </>
      ) : (
        <div>
          <Skeleton variant='rectangular' className={styles.loadingText} />
          <Skeleton variant='rectangular' className={styles.loadingText} />
          <Skeleton variant='rectangular' className={styles.loadingText} />
        </div>
      )}
    </div>
  );
}
